import { Icon } from "semantic-ui-react";
import styles from "./shared.module.scss";

export const CheckCircle = ({ saved }: { saved: string }) => (
  <>
    <Icon name="check circle" color="green" />
    <span className={styles.toastTitle}>{saved}</span>
  </>
);
